import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/utils/routes';
import { getRouteURI } from 'src/utils/url';
import { getUuid } from 'src/utils/url';

const ViewRunButton = ({ runUri }) => {
  if (!runUri) return null;

  return (
    <Link to={getRouteURI(routes.run, { uuid: getUuid(runUri) })}>
      <button
        type='button'
        className='piece-overview-action-button piece-overview-action-button--run'
      >
        <FontAwesomeIcon
          icon={faArrowAltCircleRight}
          className='piece-overview-action-button__icon'
        />
        View Run
      </button>
    </Link>
  );
};

ViewRunButton.propTypes = {
  runUri: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.string.isRequired]),
};

export default ViewRunButton;
